import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f0be8863911b0014132375_1781019175220_f0c3c79c/decretos_dashboard/src/app/not-found.tsx");
